import './prototype'

export const isEmpty = (value) => {
  if (!value || value === undefined) {
    return true
  } else if (value.constructor === Object) {
    return Object.keys(value).length === 0
  } else if (value.constructor === Array) {
    return value.length === 0
  }
}

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const isIOS = () => {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
}

export const isHeadset = () => {
  return navigator.userAgent.match(/OculusBrowser/i)
}

export const isIframe = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

export const processVideoUrl = (url) => {
  if (!url) {
    return
  }
  const youTubeShort = 'https://youtu.be/'
  const vimeoShort = 'https://vimeo.com/'

  const endOfUrl = url.split('/').slice(-1)[0]
  if (url.includes('youtube.com/watch?v=')) {
    const getUrlParams = new URLSearchParams(url.split('?')[1])
    const v = getUrlParams.get('v')
    getUrlParams.delete('v')
    const params = getUrlParams.toString()
    return `https://www.youtube.com/embed/${v}?${params}`
  } else if (url.includes(youTubeShort)) {
    return `https://www.youtube.com/embed/${endOfUrl}`
  } else if (url.includes(vimeoShort)) {
    return `https://player.vimeo.com/video/${endOfUrl}`
  }
  return url
}

export const getBrowserType = () => {
  const userAgent = navigator.userAgent
  let browser = ''
  if (userAgent.indexOf('Chrome') > -1) {
    browser = 'chrome'
  } else if (userAgent.indexOf('CriOS') > -1) {
    browser = 'chrome'
  } else if (userAgent.indexOf('Safari') > -1) {
    browser = 'safari'
  } else if (userAgent.indexOf('Opera') > -1) {
    browser = 'opera'
  } else if (userAgent.indexOf('Firefox') > -1) {
    browser = 'firefox'
  } else if (userAgent.indexOf('MSIE') > -1) {
    browser = 'ie'
  } else {
    browser = 'unknown'
  }
  return browser
}

export const includes = (array, value) => {
  return array.indexOf(value) > -1
}

export const isPortrait = () => {
  return window.innerHeight > window.innerWidth
}

export const enterFullscreen = (element = document.documentElement) => {
  if (element.requestFullscreen) {
    element.requestFullscreen()
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen()
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen()
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT) // eslint-disable-line
  }
}

export const getFullscreenElement = () => {
  return (
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement
  )
}

export const exitFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  }
}

export const loadImage = async (url = '', callback = () => {}, onprogress = e => {}, onerror = () => {}) => {
  if (typeof url === 'string' || url instanceof String) {
    try {
      const xmlHttp = new XMLHttpRequest() // eslint-disable-line
      xmlHttp.open('GET', url, true)
      xmlHttp.responseType = 'arraybuffer'
      xmlHttp.onload = () => {
        callback()
      }
      xmlHttp.onprogress = e => {
        onprogress(Math.ceil(e.loaded / e.total * 100))
      }
      xmlHttp.onerror = () => {
        onerror()
      }
      xmlHttp.send()
    } catch (e) {
    }
  } else if ((typeof url === 'object' || url instanceof Object) && url.length > 0) {
    url = url.filter(uniUrl => uniUrl)
    const loadAllImages = url.map(uniUrl => {
      return new Promise((resolve, reject) => {
        try {
          const xmlHttp = new XMLHttpRequest() // eslint-disable-line
          xmlHttp.open('GET', uniUrl, true)
          xmlHttp.responseType = 'arraybuffer'
          xmlHttp.onload = () => {
            resolve()
          }
          xmlHttp.onerror = () => {
            onerror()
            reject(new Error('image load error'))
          }
          xmlHttp.send()
        } catch (error) {
          reject(new Error(error))
        }
      })
    })
    await Promise.all(loadAllImages).then(() => {
      callback()
    }).catch(error => {
      console.error(error)
    })
  }
}

export const getFilename = (string) => {
  if (!string) {
    return string
  }
  /* eslint-disable */
  const match = string.match(/([^\/]+)\.\w+(?=\?|$)/)
  return match ? match[0] : ''
  /* eslint-enable */
}

// 計算 instr 在 string 裡出現幾次
export const countText = (string, instr) => {
  const re = new RegExp(instr, 'g')
  return (string.match(re) || []).length
}

// obj,'1.2.3' -> multiIndex(obj,['1','2','3'])
export const getPath = (obj, is) => {
  return multiIndex(obj, is.split('.'))
}

// obj,['1','2','3'] -> ((obj['1'])['2'])['3']
export const multiIndex = (obj, is) => {
  return is.length ? multiIndex(obj[is[0]], is.slice(1)) : obj
}

export const completeAssign = (target, ...sources) => {
  sources.forEach(source => {
    const descriptors = Object.keys(source).reduce((descriptors, key) => {
      descriptors[key] = Object.getOwnPropertyDescriptor(source, key)
      return descriptors
    }, {})
    // Object.assign 預設會複製可列舉的Symbols。
    Object.getOwnPropertySymbols(source).forEach(sym => {
      const descriptor = Object.getOwnPropertyDescriptor(source, sym)
      if (descriptor.enumerable) {
        descriptors[sym] = descriptor
      }
    })
    Object.defineProperties(target, descriptors)
  })
  return target
}

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
export const getIEVersion = () => {
  const ua = window.navigator.userAgent
  const msie = ua.indexOf('MSIE ')
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
  }

  const trident = ua.indexOf('Trident/')
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:')
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }

  const edge = ua.indexOf('Edge/')
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
  }

  // other browser
  return false
}

export const isIE = () => {
  const ua = window.navigator.userAgent
  const msie = ua.indexOf('MSIE ')
  const trident = ua.indexOf('Trident/')
  return (msie > 0 || trident > 0)
}

export const isEqual = (a, b) => {
  const aKeys = Object.getOwnPropertyNames(a)
  const bKeys = Object.getOwnPropertyNames(b)
  if (aKeys.length !== bKeys.length) {
    return
  }
  return aKeys.every(key => a[key] === b[key])
}

export const isObject = (obj = {}) => {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

export const addParameter = (url = location.href, param) => {
  url += (url.split('?')[1] ? '&' : '?') + param
  return url
}

export const xhr = (url, type = 'get') => {
  return new Promise((resolve, reject) => {
    const XMLRequest = new XMLHttpRequest() // eslint-disable-line
    XMLRequest.open(type, url, true)
    XMLRequest.send()
    XMLRequest.onload = resp => {
      if (XMLRequest.status === 200) {
        resolve(resp)
      } else {
        reject(resp)
      }
    }
  })
}

export const generateRandomString = (s = 5) => {
  let text = String() // use '' will cause not defined error ??
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_'
  for (let i = 0; i < s; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

export const tap = f => x => { f(x); return x }
export const map = f => xs => xs.map(f)
export const filter = f => xs => xs.filter(f)
export const sort = f => xs => xs.sort(f)
export const pipe = (...fns) => x => fns.reduce((x, fn) => fn(x), x)
export const pipeP = (...fns) => x => fns.reduce((p, fn) => p.then(fn), Promise.resolve(x))
export const reduce = f => z => xs => xs.reduce((acc, x) => f(acc, x), z)

export const tryAsync = asyncFn => param => asyncFn(param).catch((err) => {
  console.error(err)
  return param
})

export const str2Ascii = string => [...string]
  .map(str => str
    .charCodeAt(0)
    .toString(16))
  .join('')
export const ascii2str = ascii => ascii.match(/.{2}/g)
  .map(hex => parseInt(hex, 16))
  .map(chr => String.fromCharCode(chr))
  .join('')

export class PromiseService {
  constructor (name) {
    this.name = name || Math.random()
    this.resolve = null
  }

  exec (execFn) {
    PromiseService.instances[this.name] = this
    return new Promise((resolve) => {
      this.resolve = resolve
      execFn()
    })
  }

  static resolve (name, ...args) {
    this.instances[name] && this.instances[name].resolve && this.instances[name].resolve(...args)
    this.instances[name] = null
  }
}
PromiseService.instances = {}
